import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import MainPage from '../Pages/MainPage';
import TabMode from '../Enums/TabMode';

function MainPageRouter(): JSX.Element {
  
    return (
        <BrowserRouter>
            <Routes>
                <Route path='/' element={<MainPage tabMode={TabMode.VESSELS} subView={null} />} />
                <Route path='/vessels' element={<MainPage tabMode={TabMode.VESSELS} subView={null} />} />
                <Route path='/settings' element={<MainPage tabMode={TabMode.SETTINGS} subView={null} />} />
                <Route path='/settings/about' element={<MainPage tabMode={TabMode.SETTINGS} subView='about' />} />
                <Route path='*' element={<MainPage tabMode={TabMode.VESSELS} subView={null} />} />
            </Routes>
        </BrowserRouter>
    );
}

export default MainPageRouter;